"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
var AutomatedPostFrequency;
(function (AutomatedPostFrequency) {
    AutomatedPostFrequency["PT24H"] = "PT24H";
    AutomatedPostFrequency["PT48H"] = "PT48H";
    AutomatedPostFrequency["PT72H"] = "PT72H";
    AutomatedPostFrequency["PT96H"] = "PT96H";
    AutomatedPostFrequency["PT120H"] = "PT120H";
    AutomatedPostFrequency["PT168H"] = "PT168H";
    AutomatedPostFrequency["PT336H"] = "PT336H";
    AutomatedPostFrequency["PT720H"] = "PT720H";
})(AutomatedPostFrequency = exports.AutomatedPostFrequency || (exports.AutomatedPostFrequency = {}));
exports.isAutomatedPostsNoFilesMessageDetails = (details) => details !== null && details.type === "automated_posts_no_files";
class AutomatedPostProvider extends DataProvider_1.default {
    get fragments() {
        return {
            AutomatedPost: () => `
        ... on AutomatedPost {
          id
          userId
          vaultCategoryId
          vaultCategory {
            ${this.getFragment("VaultCategory")}
            totalFilesCount
            files {
              id
              urlPart
              contentType
            }
          }
          levelId
          pricePackageId
          frequency
          captions
        }
      `,
            AutomatedPostUserSettings: () => `
        ... on AutomatedPostUserSettings {
          userId
          enabled
        }
      `,
        };
    }
    search({ data }) {
        return this.query("automatedPostSearch", { data }, this.getFragment("AutomatedPost"));
    }
    create({ data }) {
        return this.mutate("automatedPostUpdate", { data }, this.getFragment("AutomatedPost"));
    }
    update({ data }) {
        return this.mutate("automatedPostUpdate", { data }, this.getFragment("AutomatedPost"));
    }
    delete(id) {
        return this.mutate("automatedPostDelete", { id });
    }
    userSettingsSearch({ userId }) {
        return this.query("automatedPostUserSettingsSearch", { userId }, this.getFragment("AutomatedPostUserSettings"));
    }
    userSettingsUpdate({ data, }) {
        return this.mutate("automatedPostUserSettingsUpdate", { data }, this.getFragment("AutomatedPostUserSettings"));
    }
}
exports.AutomatedPostProvider = AutomatedPostProvider;
//# sourceMappingURL=AutomatedPosts.js.map